import React from "react";
import Alert from "react-bootstrap/Alert";
import { useTranslation } from "react-i18next";

interface ErrorMessageProps {
  text: string;
  className?: string;
  inContainer?: boolean;
  containerClassName?: string;
}

export default function ErrorMessage(props: ErrorMessageProps) {
  const { t } = useTranslation();

  if (props.inContainer) {
    return (
      <div
        className={
          "container " +
          (props.containerClassName ? props.containerClassName : "")
        }
      >
        <Alert variant="danger" className={"mt-5 " + props.className}>
          {t(props.text)}
        </Alert>
      </div>
    );
  }

  return (
    <Alert variant="danger" className={props.className}>
      {t(props.text)}
    </Alert>
  );
}
